import { Navigator } from "../../main_components/navigator.js";
import Styles from "./products.module.css";
import { Products, ProductsHeader } from "./products_components.js";
import test1Img from "../../images/11905945_4857949.jpg";
import test2Img from "../../images/88805032_DJV MAR 1045-01.jpg";
import test3Img from "../../images/66243604_9603059.jpg";
import { useState } from "react";
export const ProductsBody = ( props ) => {
    const {  } = props;
    const { Body, Content } = Styles;
    const [ filter, setFilter] = useState("All");
    const products = [
        { image: test1Img, imageTheme: "#ffc107", name: "Test Medium", nameTheme: "#607d8b", link: "/products/view_product", category: "programming" },
        { image: test2Img, imageTheme: "#009688", name: "Test Medium", nameTheme: "#795548", link: "/products/view_product", category: "apps" },
        { image: test3Img, imageTheme: "#2196f3", name: "Test Medium", nameTheme: "#ff9800", link: "/products/view_product", category: "courses" },
        { image: test1Img, imageTheme: "#ffc107", name: "Test Medium", nameTheme: "#607d8b", link: "/products/view_product", category: "programming" },
        { image: test2Img, imageTheme: "#009688", name: "Test Medium", nameTheme: "#795548", link: "/products/view_product", category: "apps" },
        { image: test3Img, imageTheme: "#2196f3", name: "Test Medium", nameTheme: "#ff9800", link: "/products/view_product", category: "courses" },
        { image: test1Img, imageTheme: "#ffc107", name: "Test Medium", nameTheme: "#607d8b", link: "/products/view_product", category: "programming" },
        { image: test2Img, imageTheme: "#009688", name: "Test Medium", nameTheme: "#795548", link: "/products/view_product", category: "apps" },
        { image: test3Img, imageTheme: "#2196f3", name: "Test Medium", nameTheme: "#ff9800", link: "/products/view_product", category: "courses" },
        { image: test1Img, imageTheme: "#ffc107", name: "Test Medium", nameTheme: "#607d8b", link: "/products/view_product", category: "programming" },
        { image: test2Img, imageTheme: "#009688", name: "Test Medium", nameTheme: "#795548", link: "/products/view_product", category: "apps" },
        { image: test3Img, imageTheme: "#2196f3", name: "Test Medium", nameTheme: "#ff9800", link: "/products/view_product", category: "courses" },
    ];
    const headlines = [
        "Explore Our Product Range!",
        "Discover Our Products!",
        "Explore Our Unique Products!",
        "Dive into Our Product Line!",
        "Explore Our Product Offerings!"
    ];
    return (
        <main className={ Body }>
            <Navigator page={ "Products" }/>
            <main className={ Content }>
                <ProductsHeader
                    setFilter = { setFilter }
                    headlines = { headlines }
                />
                <Products 
                    products = { products.reverse() }
                    filter   = { filter             }
                />
            </main>
        </main>
    );
};